<template lang="pug">
	.tts-log-detail
		Loader(v-if="isLoading", :fullscreen="true")
		.flex-col.space-medium(v-if="log")
			.flex-row.justify
				.flex-col
					.font-small.upper.grey {{ $tCaption('Status') }}
					span {{status}}
				.flex-col(v-if="log.SsmlStylizer")
					.font-small.upper.grey {{ $tCaption('Stylizer') }}
					span {{log.SsmlStylizer.Name}}
			.flex-col(v-if="log.Status === 1")
				.font-small.upper.grey {{ $tCaption('Error') }}
				span {{log.Error}}
			.flex-col
				.font-small.upper.grey {{ $tCaption('SSML') }}
				pre.flex-1 {{SSML}}
			.flex-col(v-if="openAIStatus === 2")
				.font-small.upper.grey {{ $tCaption('AI response') }}
				JsonViewer(:value="openAIResponseJson")
			.flex-col(v-else)
				.font-small.upper.grey {{ $tCaption('AI response') }}
				pre.flex-1 {{openAIResponseText}}
</template>

<script>
	import Loader from 'app-core/Loader.vue';	
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import JsonViewer from 'vue-json-viewer';

	export default {
		translationCategory: 'persistent-job.Detail',
		name: 'persistent-job-detail',
		components: {
			Loader, DxButton, DxTextBox, DxTabPanel, DxSelectBox, DxDateBox, JsonViewer
		},
		props: ['id'],
		data() {
			return {				
				isLoading: 0,
				log: null
			};
		},
		created() {
			
		},
		computed: {
			status() {
				return this.log?.Status === 1 ? this.$tCaption('Error') : this.$tCaption('OK')
			},
			SSML() {
				let ssml = this.log?.Ssml;
				if (ssml) {
					return this.prettifyXML(ssml);
				}
				return null;
			},
			openAIResponseText() {
				return this.log?.OpenAiLog?.ResponseText;
			},
			openAIResponseJson() {
				let json = null;
				try {
					json = JSON.parse(this.log?.OpenAiLog?.ResponseJson);
				} catch {
					//
				}
				return json;
			},
			openAIStatus() {
				return this.log?.OpenAiLog?.Status;
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.ttsLogDetail = this;
			this.loadData();
		},		
		methods: {			
			async loadData() {
				this.isLoading++;
				this.log = await this.$Data.getExternalApi('TtsLog/Get', `id=${this.id}`).finally(() => this.isLoading--);
			},
			prettifyXML(sourceXml) {
				var xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
				var xsltDoc = new DOMParser().parseFromString([
					// describes how we want to modify the XML - indent everything
					'<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
					'  <xsl:strip-space elements="*"/>',
					'  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
					'    <xsl:value-of select="normalize-space(.)"/>',
					'  </xsl:template>',
					'  <xsl:template match="node()|@*">',
					'    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
					'  </xsl:template>',
					'  <xsl:output indent="yes"/>',
					'</xsl:stylesheet>',
				].join('\n'), 'application/xml');

				var xsltProcessor = new XSLTProcessor();    
				xsltProcessor.importStylesheet(xsltDoc);
				var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
				var resultXml = new XMLSerializer().serializeToString(resultDoc);
				return resultXml;
			}
		}
	};
</script>

<style lang='scss'>
	.tts-log-detail {
		.jv-container .jv-code {
			padding: 4px !important;
		}

		pre {
			white-space: pre-wrap;
			margin: 0px;
			font-weight: 100;
			font-size: 12px;
		}
	}
</style>
